import { Box, Divider } from '@mui/material';
import { useState } from 'react';

import { type VaSearchInput } from '../../dtos';
import { trpc } from '../../trpc';
import { SearchInput } from './components/SearchInput';
import { SearchResultContent } from './components/SearchResultContent';
import { SearchSidebar } from './components/SearchSidebar';

function initializeMap(): VaSearchInput {
  return {
    titel: new URLSearchParams(window.location.search).get('titel') ?? undefined,
    sapstatus: [],
    geschaeftsbereich: [],
    klassifizierung: [],
    buchungsnummer: [],
    ortkuerzel: [],
  };
}

export const SearchPage: React.FC = () => {
  const [searchParams, setSearchParams] = useState(initializeMap);
  const searchQuery = trpc.veranstaltung.getVeranstaltungenSearch.useQuery(searchParams);

  // eslint-disable-next-line @typescript-eslint/require-await
  const filterCallback = async (newParams: Partial<VaSearchInput>): Promise<void> => {
    setSearchParams((prevSearchParams) => ({
      ...prevSearchParams,
      ...newParams,
    }));
  };

  // eslint-disable-next-line @typescript-eslint/require-await
  const handleTextInput = async (titel: string): Promise<void> => {
    setSearchParams((prevSearchParams) => {
      const updatedParams = {
        ...prevSearchParams,
        titel,
      };

      const url = new URL(window.location.href);
      if (titel.length > 0) {
        url.searchParams.set('titel', titel);
      } else {
        url.searchParams.delete('titel');
      }

      window.history.replaceState({}, '', url.toString());

      return updatedParams;
    });
  };

  return (
    <Box display="flex" flexDirection="column" gap={2} padding={0} justifyContent="center" height="100%">
      <Box display="flex" justifyContent="center" padding={2}>
        <SearchInput search={handleTextInput} initInput={searchParams.titel ?? ''} />
      </Box>
      <Box display="flex" flexDirection="row" gap={2}>
        <Box width="15vw" minWidth="10rem">
          <SearchSidebar searchParams={searchParams} filterCallback={filterCallback} />
        </Box>
        <Divider orientation="horizontal" sx={{ borderWidth: 1 }} />
        <SearchResultContent
          filterCallback={filterCallback}
          loading={searchQuery.isLoading}
          veranstaltungen={searchQuery.data ?? []}
        />
      </Box>
    </Box>
  );
};
